/*********************************************************************
 *
 * AttachmentViewer.jsx
 *
 * Composant générique d'affichage des pièces jointes.
 *
 * Gère :
 *
 * - Images
 * - Vidéos
 * - PDF
 * - Word
 * - Excel
 * - PowerPoint
 * - ZIP
 * - Audio
 * - Fichiers texte
 * - Fichiers source
 *
 * Toute la logique d'affichage est déléguée à FilePreview.jsx
 *
 *********************************************************************/

import React from "react";
import FilePreview from "./FilePreview";
export default function AttachmentViewer({
    url,
    fileName,
    title = null,
    className = "",
    fileSize = null

}) {

    //----------------------------------------------------
    // Aucun fichier
    //----------------------------------------------------

    if (!url || !fileName) {
        return null;
    }


    //----------------------------------------------------
    // Render
    //----------------------------------------------------

    return (
        <div
            className={

                `attachment-viewer
                 mb-3
                 ${className}`
            }
        >
            {
                title && (
                    <h6
                        className="
                        fw-bold
                        mb-2                        "
                    >
                        {title}
                    </h6>
                )
            }

            <FilePreview
                url={url}
                fileName={fileName}
                fileSize={fileSize}

            />
        </div>

    );

}